"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ykbUtils = require("ykb-utils");
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _reactResizeDetector = require("react-resize-detector");
var _StyledInputHoc = require("./styled/StyledInputHoc");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ViewMode(_ref) {
  var _elementRef$current;
  var prefixCls = _ref.prefixCls,
    className = _ref.className,
    viewMode = _ref.viewMode,
    viewStatus = _ref.viewStatus,
    disableEllipsisControl = _ref.disableEllipsisControl,
    showEllipsisTooltip = _ref.showEllipsisTooltip,
    viewValue = _ref.viewValue,
    children = _ref.children,
    theme = _ref.theme,
    hasError = _ref.hasError,
    touched = _ref.touched,
    validating = _ref.validating,
    customViewMode = _ref.customViewMode,
    size = _ref.size,
    viewModeHeight = _ref.viewModeHeight;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hasEllipsis = _useState2[0],
    setHasEllipsis = _useState2[1];
  var _useResizeDetector = (0, _reactResizeDetector.useResizeDetector)({
      refreshMode: 'debounce',
      refreshRate: 500
    }),
    width = _useResizeDetector.width,
    height = _useResizeDetector.height,
    elementRef = _useResizeDetector.ref;
  var checkElementHasEllipsis = (0, _react.useCallback)(function () {
    if (!elementRef.current) {
      return false;
    }
    var element = elementRef.current;
    return element.clientHeight < element.scrollHeight || element.clientWidth < element.scrollWidth;
  }, []);
  function checkEllipsis() {
    if (disableEllipsisControl === true) {
      setHasEllipsis(false);
      return;
    }
    var isEllipsisActive = checkElementHasEllipsis();
    if (isEllipsisActive !== hasEllipsis) {
      setHasEllipsis(isEllipsisActive);
    }
  }
  (0, _react.useEffect)(function () {
    if (!!viewMode) {
      checkEllipsis();
    }
  }, [disableEllipsisControl, viewValue, width, height, viewMode]);
  var viewCls = (0, _classnames.default)('view-mode-value', (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls), prefixCls), "table-xs", size === 'xsmall'));
  var isObjectViewMode = (0, _typeof2.default)(viewMode) === 'object';
  var customStyle = isObjectViewMode ? {
    color: (viewMode === null || viewMode === void 0 ? void 0 : viewMode.color) || 'none'
  } : {};
  var ellipsis = !!viewMode && disableEllipsisControl !== true && !viewModeHeight;
  var showTooltip = hasEllipsis && showEllipsisTooltip;
  var showTitle = hasEllipsis && !showEllipsisTooltip;
  return /*#__PURE__*/_react.default.createElement(_StyledInputHoc.StyledInputHoc, {
    hasError: hasError,
    touched: touched,
    validating: validating,
    theme: theme,
    viewMode: !!viewMode,
    ellipsis: ellipsis,
    style: customStyle,
    className: className ? className : (0, _classnames.default)(className, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, prefixCls, true), "".concat(prefixCls, "-view-mode"), !!viewMode))
  }, !!viewMode && customViewMode === false && /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({
    getTooltipContainer: _ykbUtils.containerChecker,
    prefixCls: "ykb-tooltip",
    placement: "top",
    overlay: viewValue,
    destroyTooltipOnHide: !hasEllipsis
  }, showTooltip ? {} : {
    visible: false
  }), /*#__PURE__*/_react.default.createElement(_StyledInputHoc.StyledViewModeValue, (0, _extends2.default)({
    theme: theme,
    ref: elementRef,
    className: viewCls
  }, showTitle && {
    title: elementRef === null || elementRef === void 0 ? void 0 : (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.textContent
  }, {
    size: size,
    viewModeHeight: viewModeHeight
  }), viewValue)), /*#__PURE__*/_react.default.createElement("div", {
    className: !!viewMode && customViewMode === false ? 'hidden' : '',
    style: customStyle
  }, children));
}
ViewMode.propTypes = {
  viewMode: PropTypes.bool,
  disableEllipsisControl: PropTypes.bool,
  showEllipsisTooltip: PropTypes.bool,
  viewValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]),
  prefixCls: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string
};
ViewMode.defaultProps = {
  disableEllipsisControl: false,
  showEllipsisTooltip: true,
  prefixCls: 'ykb-input-hoc',
  className: ''
};
var _default = exports.default = ViewMode;